import CookieService from './Cookies';

export default CookieService;
